import React from 'react';
import { BookOpenIcon, DownloadIcon, FileTextIcon, PlayCircleIcon, PresentationIcon, SparklesIcon } from 'lucide-react';
import { Panel } from '../ui/Panel';
import { Badge } from '../ui/Badge';
import { examTimetable, resources } from '../../data/academics';
import type { LearningResource } from '../../types/academic';
const ICONS: Record<LearningResource['kind'], React.ReactNode> = {
  Notes: <FileTextIcon className="h-4 w-4" data-id="element-326" data-mp="3hnzfu4fyvijj" />,
  Slides: <PresentationIcon className="h-4 w-4" data-id="element-327" data-mp="3hpsofpa54cu6" />,
  Recording: <PlayCircleIcon className="h-4 w-4" data-id="element-328" data-mp="3cwr431r5zl37" />,
  'Past paper': <FileTextIcon className="h-4 w-4" data-id="element-329" data-mp="3cv6c9jw8ig91" />,
  Reading: <BookOpenIcon className="h-4 w-4" data-id="element-330" data-mp="37yy1eip2l97o" />
};
export function ResourcesPanel() {
  return <div className="grid gap-6 lg:grid-cols-3" data-id="element-331" data-mp="33x448ke32nc9">
      <div className="lg:col-span-2" data-id="element-332" data-mp="33u85wuybpwna">
        <Panel title="Course materials" description="Published by lecturers and departmental associations." bodyClassName="p-0" data-id="element-333" data-mp="2yxrik2yy7mb9">
          <ul className="divide-y divide-line" data-id="element-334" data-mp="2u0hkjyxhu2bt">
            {resources.map(resource => <li key={resource.id} className="flex items-center gap-4 px-5 py-4" data-id="element-335" data-mp="349f5gfqow6pr">
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg border border-line bg-canvas text-ink-muted" data-id="element-336" data-mp="393jbmws4saps">
                  {ICONS[resource.kind]}
                </span>
                <div className="min-w-0 flex-1" data-id="element-337" data-mp="30a6ax8nts4t5">
                  <p className="truncate text-sm font-medium text-ink" data-id="element-338" data-mp="3nyz818g6oipc">{resource.title}</p>
                  <p className="cz-num mt-0.5 text-[13px] text-ink-muted" data-id="element-339" data-mp="3s1m7nvj3j7x3">
                    {resource.courseCode} · {resource.kind} · {resource.size} · {resource.addedAt}
                  </p>
                  <p className="mt-0.5 text-[12px] text-ink-subtle" data-id="element-340" data-mp="3j05x9nsa75sv">Added by {resource.addedBy}</p>
                </div>
                <button type="button" aria-label={`Download ${resource.title}`} className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg border border-line-strong text-ink-muted transition-colors duration-150 ease-out hover:border-ink-subtle hover:text-ink" data-id="element-341" data-mp="22lwgpfua6lcl">
                  <DownloadIcon className="h-4 w-4" data-id="element-342" data-mp="1jjnnhnun46o1" />
                </button>
              </li>)}
          </ul>
        </Panel>
      </div>

      <div className="space-y-6" data-id="element-343" data-mp="19sj8wp8vmntq">
        <Panel title="Examination timetable" bodyClassName="p-0" data-id="element-344" data-mp="19rhm5nii0cw6">
          <ul className="divide-y divide-line" data-id="element-345" data-mp="14tpumulrmssi">
            {examTimetable.map(exam => <li key={exam.courseCode} className="px-5 py-3" data-id="element-346" data-mp="ztaha31hhlaj">
                <p className="cz-num text-[13px] font-semibold text-ink" data-id="element-347" data-mp="vryq3t2yos08">{exam.courseCode}</p>
                <p className="cz-num mt-0.5 text-[13px] text-ink-muted" data-id="element-348" data-mp="vttan6abmi3s">
                  {exam.date} · {exam.time}
                </p>
                <p className="text-[12px] text-ink-subtle" data-id="element-349" data-mp="2q69ha8713y96">{exam.venue}</p>
              </li>)}
          </ul>
        </Panel>

        <Panel title="Study assistant" data-id="element-350" data-mp="2l7odjyskiwfz">
          <div className="flex items-start gap-3" data-id="element-351" data-mp="2sqp8vwt7tjs9">
            <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg border border-line bg-canvas text-ink-subtle" data-id="element-352" data-mp="2spwabj4eu0l7">
              <SparklesIcon className="h-4 w-4" data-id="element-353" data-mp="32g8rr2gxhdn4" />
            </span>
            <div data-id="element-354" data-mp="32h0owhq6bjfi">
              <Badge data-id="element-355" data-mp="32ilahhuifs18">Not yet available</Badge>
              <p className="mt-2 text-[13px] leading-6 text-ink-muted" data-id="element-356" data-mp="37eablpm6hgzn">
                Summaries, practice questions and revision plans will run on Havazon AI over your own
                materials. It will never generate grades, policies or institutional records.
              </p>
            </div>
          </div>
        </Panel>
      </div>
    </div>;
}